import { useTranslation } from 'react-i18next';
import { useMediaQuery } from '@mui/material';

import LinkCell from '../Cells/LinkCell/LinkCell';

import { MediaBreakpoints } from 'hooks/Screen/useScreenSize';
import { FeromonTrap } from 'api/traps/FeromonTraps/types';

interface FeromonsInsectsExpandableProps {
  data: FeromonTrap;
  slug: string;
}
const FeromonsInsectsExpandable: React.FC<FeromonsInsectsExpandableProps> = ({ data, slug }) => {
  const { t } = useTranslation();
  const mobile = useMediaQuery(MediaBreakpoints.mobile);
  const tablet = useMediaQuery(MediaBreakpoints.tablet);
  const desktop = useMediaQuery(MediaBreakpoints.desktop);
  const largeDesktop = useMediaQuery(MediaBreakpoints.largeDesktop);

  return (
    <div className="d-flex w-100 flex-column">
      {mobile && (
        <div className="d-flex flex-column my-2">
          <div>
            <span className="me-1 fs-14 fw-bold">{t('TrapTables.Number')}</span>
          </div>
          <div>
            <LinkCell
              title={String(data?.sequence_number) || 'None'}
              link={`/feromon_trap/info/${slug}/${data.serial_number}`}
              icon="ri-eye-line"
            />
          </div>
        </div>
      )}

      {tablet && (
        <div className="d-flex flex-column my-2">
          <div>
            <span className="me-1 fs-14 fw-bold">{t('TrapTables.InteractiveMap')}</span>
            <div>
              <LinkCell
                title={data?.floor_number?.title || 'None'}
                link={`/object/plan/${data.default_plan.on_plan ? 'trap/' : ''}${slug}/${data.default_plan}/${data.serial_number}`}
                icon="ri-treasure-map-line"
              />
            </div>
          </div>
        </div>
      )}

      <div className="d-flex flex-column gap-2 justify-content-start my-2">
        {desktop && (
          <>
            <div>
              <span className="me-1 fs-14 fw-bold">{`${t('TrapTables.LastVisit')}: `}</span>
              {data?.last_visit ? new Date(data.last_visit).toLocaleString() : '-'}
            </div>
            <div>
              <span className="me-1 fs-14 fw-bold">{`${t('TrapTables.Type')}: `}</span> {data.trap_type}
            </div>
          </>
        )}
        {largeDesktop && (
          <>
            <div>
              <span className="me-1 fs-14 fw-bold">{`${t('TrapTables.SerialNumber')}: `}</span> {data.serial_number}
            </div>
            <div>
              <span className="me-1 fs-14 fw-bold">{`${t('TrapTables.Level')}: `}</span> {data.save_level}
            </div>
            <div>
              <span className="me-1 fs-14 fw-bold">{`${t('TrapTables.DateOfInstallation')}: `}</span>
              {data?.date_of_installation ? new Date(data.date_of_installation).toLocaleString() : '-'}
            </div>
          </>
        )}
      </div>
    </div>
  );
};

export default FeromonsInsectsExpandable;
